import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_URL } from '../api/base';

const ContactsSection: React.FC = () => {
  const { t, i18n } = useTranslation();
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    try {
      const res = await fetch(`${API_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name,
          surname,
          email,
          message,
          language: i18n.language
        })
      });
      const data = await res.json();
      if (res.ok) {
        setSent(true);
        setName('');
        setSurname('');
        setEmail('');
        setMessage('');
        setTimeout(() => setSent(false), 5000);
      } else {
        throw new Error(data.message || 'Ошибка отправки');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ошибка отправки сообщения');
      setTimeout(() => setError(''), 5000);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contacts" style={{ background: '#fff', padding: '64px 24px 80px' }}>
      <div style={{ maxWidth: 1000, margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 14 }}>
          <span className="section-tag">{t('contacts.subtitle', 'Контакты')}</span>
        </div>
        <h2 className="h2-center" style={{ marginBottom: 34 }}>
          {t('contacts.title')}
        </h2>

        <div
          className="card-base grid-contacts"
          style={{ borderRadius: 32 }}
        >
          {/* LEFT — dark panel */}
          <div style={{ background: '#14532D', color: '#fff', padding: 34 }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
              <div>
                <div style={{ font: "600 14px 'Montserrat Alternates', sans-serif", opacity: 0.85 }}>
                  {t('contacts.address')}
                </div>
                <div style={{ font: "400 15px 'Golos Text', sans-serif", marginTop: 5 }}>
                  {t('contacts.address_value')}
                </div>
              </div>
              <div>
                <div style={{ font: "600 14px 'Montserrat Alternates', sans-serif", opacity: 0.85 }}>
                  {t('contacts.phone')}
                </div>
                <div style={{ font: "400 15px 'Golos Text', sans-serif", marginTop: 5 }}>
                  {t('contacts.phone_value')}
                </div>
              </div>
              <div>
                <div style={{ font: "600 14px 'Montserrat Alternates', sans-serif", opacity: 0.85 }}>
                  Email
                </div>
                <div style={{ font: "400 15px 'Golos Text', sans-serif", marginTop: 5 }}>
                  jashyldem@gmail.com
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT — form */}
          <form
            onSubmit={handleSubmit}
            style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: 34 }}
          >
            <div style={{ font: "600 16px 'Golos Text', sans-serif", color: '#333' }}>
              {t('contacts.form.title')}
            </div>
            <input
              className="f"
              placeholder={t('contacts.form.name') as string}
              value={name}
              onChange={e => setName(e.target.value)}
              required
              disabled={isSubmitting}
              autoComplete="given-name"
            />
            <input
              className="f"
              placeholder={t('contacts.form.surname', 'Фамилия') as string}
              value={surname}
              onChange={e => setSurname(e.target.value)}
              required
              disabled={isSubmitting}
              autoComplete="family-name"
            />
            <input
              className="f"
              type="email"
              placeholder={t('contacts.form.email') as string}
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              disabled={isSubmitting}
              autoComplete="email"
            />
            <textarea
              className="f"
              rows={4}
              placeholder={t('contacts.form.message', 'Сообщение') as string}
              value={message}
              onChange={e => setMessage(e.target.value)}
              required
              disabled={isSubmitting}
              style={{ resize: 'none' }}
            />
            <button
              type="submit"
              className="pill-btn"
              style={{ justifyContent: 'center', fontSize: 16 }}
              disabled={isSubmitting}
            >
              {isSubmitting ? t('contacts.form.sending') || 'Отправка...' : t('contacts.form.send')}
            </button>
            {sent && (
              <p style={{ color: '#0B7A43', fontSize: 13 }}>{t('contacts.form.sent')}</p>
            )}
            {error && <p style={{ color: '#c33', fontSize: 13 }}>{error}</p>}
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactsSection;
